import {
  RelatedFilesQueryParamsType,
  RelatedFilesQueryResponseType,
} from '@/common/queries/relatedFiles/relatedFilesQuery.type.ts';
import { fetchApi } from '@/config/axiosSetting.ts';

export const relatedFilesQueryFunction = ({
  id,
}: RelatedFilesQueryParamsType): Promise<RelatedFilesQueryResponseType> =>
  fetchApi.get(`my_files/${id}/related_file/`);
